import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { FAQ_ITEMS } from '../mock';

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section id="sss" className="bg-[#f7f2ec] py-24 lg:py-32">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <p className="text-[11px] tracking-[0.3em] uppercase text-stone-500 text-center">Sıkça Sorulan Sorular</p>
        <h2 className="mt-3 font-serif text-4xl lg:text-6xl leading-none text-stone-900 text-center">
          Aklınızdaki <em className="italic font-light">sorular?</em>
        </h2>

        <div className="mt-14 divide-y divide-stone-200 border-y border-stone-200">
          {FAQ_ITEMS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={i}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full py-6 flex items-center justify-between gap-6 text-left"
                >
                  <span className="font-serif text-lg lg:text-xl text-stone-900">{item.q}</span>
                  <span className="shrink-0 h-8 w-8 flex items-center justify-center border border-stone-300 rounded-full text-stone-800">
                    {isOpen ? <Minus className="h-3.5 w-3.5" /> : <Plus className="h-3.5 w-3.5" />}
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-500 ${
                    isOpen ? 'grid-rows-[1fr] opacity-100 pb-6' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="text-[14.5px] leading-relaxed text-stone-600 pr-14">{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
